import { Location } from '@angular/common';
import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HttpService } from 'src/app/http.service';
import { CloudNotificationStyle } from 'src/app/models/cloud-notification-style.model';
import { SetCloudPassword } from 'src/app/models/SetCloudPassword.model';
import { Observable } from 'rxjs/internal/Observable';
import { MarketplaceTokenRequest } from 'src/app/models/marketplace-token-request.model';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { SubscriptionRequest } from 'src/app/models/subscription-request.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import Helper from 'src/app/Util/helper';
import { AuthenticationService } from '../../services/authentication.service';
import { NcacheSubscription } from 'src/app/models/ncache-subscription.model';
import { CloudSubscriptionService } from 'src/app/cloud-subscription/services/cloud-subscription.service';
import { CloudAuthenticationService } from 'src/app/services/cloud-authentication.service';
import { CloudPlanResponse } from 'src/app/models/cloud-plan-response.model';
import { FreeTrialExpiryResponse } from 'src/app/models/responses/free-trial-expiry-response.model';
import { OTPVerificationRequest } from 'src/app/models/requests/otp-verification-request';
import { SubscriptionCreateService } from 'src/app/cloud-subscription/components/subscription-create/services/subscription-create.service';
import { environment } from 'src/environments/environment';
import { RegisterUserFromLeadRequest } from 'src/app/models/RegisterUserFromLeadRequest';
import { EmailVerifiedRequest } from 'src/app/models/EmailVerifiedRequest';
import { AuthUtils } from 'src/app/Util/auth-utils';
import { CreateSubscriptionRequest } from 'src/app/interfaces/subscription.interface';
import { CloudProfileService } from 'src/app/services/cloud-profile.service';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { StorageKeys } from 'src/app/Util/storage-keys';
import { ActivateSubscriptionRequest } from 'src/app/interfaces/services/subscription.interface';
import { API_ERRORS, SUCCESS } from 'src/app/Util/constants';

@Component({
  selector: 'app-set-password-cloud',
  templateUrl: './set-password-cloud.component.html',
  styleUrls: ['./set-password-cloud.component.sass']
})
export class SetPasswordCloudComponent implements OnInit {
  @Input() cloudPlanResponse: CloudPlanResponse;
  isActivatingPlan: boolean = false;
  form: FormGroup;
  loading = false;
  submitted = false;
  email: string = '';
  password: string = '';
  stateId: string = '';
  vendor: string = '';
  confirmPassword: string = '';
  cloudPlanPeriod = '';
  cloudSubscription: NcacheSubscription;
  freeTrialExpiry: string;
  redirectModelForm: FormGroup;
  modelEvent: any;
  verificationOTP: string;
  isOtpVerifyDisabled = true;
  otpVerifyDisabled = true;
  resendOtpLoading: boolean = false;
  otpResendDuration: number = 0;
  resendSuccessful: boolean = false;
  isOTPResendLoading: boolean = false;
  resendAllowed: boolean = true;
  faCheckCircle = faCheckCircle;
  successfulRegistrationModalStepOne: boolean = true;
  passwordShow: boolean = false;
  passwordConfirmShow: boolean = false;
  subscriptionId : string = ''
  isCheckingOTPVerification: boolean = false
  @ViewChild('creatingSubscription') creatingSubscription: TemplateRef<any>;
  @ViewChild('successfulRegistrationModal') successfulRegistrationModal: any;
  @ViewChild('otpVerificationModal') otpVerificationModal: any;
  @ViewChild('successfulRegistrationPaidModal') successfulRegistrationPaidModal: any;
  isOtpVerificationLoading: boolean = false;
  verifyOtpLoading: boolean = false;
  private subscriptionRequest: SubscriptionRequest = new SubscriptionRequest();
  cloudOfferDisplayName : string = ''
  unsubscribeSubject = new Subject();
  subscriptionUid: string;
  authCode : string = ''
  private userFeched = new Subject<boolean>()
  constructor(private notificationSvc: CloudNotificationService, private AuthenticationService: AuthenticationService,
    private formBuilder: FormBuilder, private router: Router, private http: HttpService, private route: ActivatedRoute,
    private location: Location, private modalSvc: NgbModal, private subscriptionSvc: CloudSubscriptionService,
    private authSvc: CloudAuthenticationService,
    private subscriptionCreateSvc: SubscriptionCreateService,
    private profileSvc:CloudProfileService,
    private localStorage:LocalStorageService
  ) {
    this.cloudPlanPeriod = this.subscriptionCreateSvc.cloudPlanResponse.period;
  }

  toggleOTPBtn(): void {
    this.isOtpVerifyDisabled = this.verificationOTP.trim() === '';
  }

  ngOnInit() {
    this.route.queryParams.subscribe(queryParams => {
      this.email = queryParams.email ? atob(queryParams.email) : '';
      this.stateId = queryParams.stateId ? queryParams.stateId : '';
      this.vendor = queryParams.vendor ? queryParams.vendor : '';
    });
    this.getRouteStateData()
    this.observeUserFetched()

    this.redirectModelForm = this.createRedirectModelForm();

    this.form = this.formBuilder.group({
      password: ['', [Validators.required,
        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z\\d\\w\\W]{8,}$')]],
      confirmPassword: ['', [Validators.required]]
    }, { validator: this.ConfirmedValidator('password', 'confirmPassword') });
  }

  private getRouteStateData(){
    this.cloudOfferDisplayName = history.state.cloudOfferDisplayName
  }

  ConfirmedValidator(password: string, confirmPassword: string) {
    return (formGroup: FormGroup) => {
      const Password = formGroup.controls[password];
      const ConfirmPassword = formGroup.controls[confirmPassword];
      if (ConfirmPassword.errors && !ConfirmPassword.errors.confirmedValidator) {
        return;
      }
      if (Password.value !== ConfirmPassword.value) {
        ConfirmPassword.setErrors({ confirmedValidator: true });
      } else {
        ConfirmPassword.setErrors(null);
      }
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit(verificationOTPModal: any) {
    this.submitted = true;
    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }
    this.loading = true;
    this.modelEvent = verificationOTPModal;

    this.password = this.f.password.value;
    var encoded_email = btoa(this.email);

    if (this.stateId != '' && this.vendor != '') {
      var registerUserFromLeadRequest = new RegisterUserFromLeadRequest();
      registerUserFromLeadRequest.email = encoded_email;

      this.subscriptionSvc.registerUserFromLead(registerUserFromLeadRequest).subscribe(resp => {
        var emailVerifiedRequest = new EmailVerifiedRequest();
        emailVerifiedRequest.email = encoded_email;

        this.subscriptionSvc.isEmailVerified(emailVerifiedRequest).subscribe(resp => {
          this.SetPassword(false);

        }, (error) => {
          this.loading = false;
          this.createSubscriptionErrorHandler(error);
        });
      }, (error) => {
        this.loading = false;
        this.notificationSvc.createorUpdateToastNotification('register',
          Helper.resolveErrorMessage(error), CloudNotificationStyle.danger);
      });
    }
    else {
      var emailVerifiedRequest = new EmailVerifiedRequest();
      emailVerifiedRequest.email = encoded_email;

      this.subscriptionSvc.isEmailVerified(emailVerifiedRequest).subscribe(resp => {
        this.SetPassword(true);

      }, (error) => {
        this.loading = false;
        this.createSubscriptionErrorHandler(error);
      });
    }
  }

  private getSubscriptionId():string{
    return this.localStorage.getItemSessionStorage(StorageKeys.SubscriptionId)
  }

  private getUserDetails(){
    if(this.getSubscriptionId()){
      this.profileSvc.getUserDetails().subscribe({
        next:(res)=>{
          if(res.email != this.email){
           this.logoutUser()
          }
          this.userFeched.next(true)
        },
        error:(err)=>{

        }
      })
    }
  }

  private logoutUser(){
    this.authSvc.logout(false,false,false,false)
  }



  private updateResendOtpVerificationStates(resendSuccessful: boolean, isResendLoading: boolean, otpResendDuration: number): void {
    this.resendSuccessful = resendSuccessful;
    this.isOTPResendLoading = isResendLoading;
    this.otpResendDuration = otpResendDuration;
  }

  verifyOTP(): void {

    this.verifyOtpLoading = true;

    this.notificationSvc.removeToastNotification('new-subscriber');

    this.subscriptionSvc.verifyOTP(this.email,this.verificationOTP).pipe(takeUntil(this.unsubscribeSubject)).subscribe(res => {
      this.closeModal();

      localStorage.removeItem('alreadyRegisteredRadio');
      localStorage.removeItem('email');

      this.notificationSvc.createorUpdateToastNotification('otp-verified', res, CloudNotificationStyle.success);
      this.paidSubscriptionRegistrationSucess()
    }, err => {
      this.verifyOtpLoading = false;
      this.otpVerifyDisabled = false;
      this.notificationSvc.createToastNotification(
        'new-subscriber',
        Helper.resolveErrorMessage(err),
        CloudNotificationStyle.danger
      );
    });
  }

  resolveAuthToken() {

    const authCode = AuthUtils.encodeEmailAndPassword(this.email, this.password);

    this.notificationSvc.removeToastNotification('auth-token');
    this.notificationSvc.removeToastNotification('otp-verified');
    this.authSvc.resolveAuthToken({ code: authCode }, true).subscribe({

      next: () => {
        this.isActivatingPlan = true;
            this.redirectToPlanSelection(this.cloudPlanPeriod);
      },

      error: (err) => {
        this.notificationSvc.createToastNotification('auth-token', 'Error: ' + err, CloudNotificationStyle.danger);
      }

    })

  }

  goToDashboard() {
    this.router.navigate([environment.routes.subscription]);
  };

  
  private observeUserFetched(){
    this.userFeched.subscribe((data)=>
      this.localStorage.setItemSessionStorage(StorageKeys.SubscriptionId, this.subscriptionId)
    )
  }



  SetPassword(onlySetPassword: boolean): void {

    this.loading = true;
    this.authCode = AuthUtils.encodeEmailAndPassword(this.email,this.password)
        let createSubscriptionRequest: CreateSubscriptionRequest = {
          marketPlaceToken: this.stateId,
          cloudVendor: this.vendor,
          authCode: this.authCode
        }

        this.notificationSvc.createorUpdateToastNotification('new-susbcription',
          this.creatingSubscription, CloudNotificationStyle.info);

          this.subscriptionSvc.createSubscription(createSubscriptionRequest).subscribe({
            next:(res)=>{
              this.getUserDetails()
            this.subscriptionId = res.subscription.id
            var setPasswordRequest = new SetCloudPassword();
            setPasswordRequest.email = btoa(this.email);
            setPasswordRequest.password = btoa(this.password);
              this.AuthenticationService.setCloudPassword(setPasswordRequest).subscribe({
                next:(res)=>{
                  this.openModal(this.otpVerificationModal, 'otpVerificationModal');
                },
                error:(err)=>{
                  this.loading = false;
                  this.notificationSvc.createorUpdateToastNotification('set-password',
                    Helper.resolveErrorMessage(err), CloudNotificationStyle.danger);
                }
              })
            }
          })
  }

  redirectToPlanSelection(period: string) {
    this.router.navigate([environment.routes.available_plans], { queryParams: { subscriptionId: this.subscriptionId, period: period}});
    this.modalSvc.dismissAll(this.modelEvent);
  }

  private openVerificationOTP(){

  }

  resendOTP(): void {

    this.resendSuccessful = false;
    this.resendOtpLoading = true;


    this.subscriptionSvc.resendOTP(this.email).pipe(takeUntil(this.unsubscribeSubject)).subscribe(res => {

      this.resendOtpLoading = false;
      this.resendSuccessful = true;
      this.resendAllowed = false;
      this.otpResendDuration = 60;

      let otpInterval = setInterval(() => {
        if (this.otpResendDuration > 0) this.otpResendDuration--;
        if (this.otpResendDuration === 0) clearInterval(otpInterval);
      }, 1000);

      this.notificationSvc.createToastNotification(
        'new-subscriber',
        res,
        CloudNotificationStyle.success
      );
    },
      (error) => {

        this.resendOtpLoading = false;
        this.otpResendDuration = Helper.resolveErrorMessage(error);

        let otpInterval = setInterval(() => {
          if (this.otpResendDuration > 0) this.otpResendDuration--;
          if (this.otpResendDuration === 0) clearInterval(otpInterval);
        }, 1000);

        this.notificationSvc.createToastNotification(
          'registration',
          `You are not allowed to resend OTP again. Please wait for ${this.otpResendDuration} seconds.`,
          CloudNotificationStyle.danger
        );
      });
  }

  verificationOTPConsentChange(value: string) {
    this.otpVerifyDisabled = value !== '' ? false : true;
    this.verificationOTP = value;
  }

  openModal(modal, modalName: string = '') {
    if (modalName === 'verificationOTPModal')
      this.modalSvc.open(modal, { windowClass: 'verificationOTPModal', backdrop: 'static', keyboard: false, centered: true });
    else if (modalName === 'successfulRegistrationModal')
      this.modalSvc.open(modal, { windowClass: 'successfulRegistrationModal', backdrop: 'static', keyboard: false, centered: true });
    else
      this.modalSvc.open(modal, { backdrop: 'static', keyboard: false, centered: true });
  }

  // createSubscriptionWithExistingAccount(subscriptionRequest: SubscriptionRequest): Observable<CreateSubscriptionResponse> {
  //   return this.subscriptionSvc.createSubscription(subscriptionRequest);
  // }

  private createSubscriptionErrorHandler(error: any) {
    this.notificationSvc.removeToastNotification('new-susbcription');
    const regex = /(account|email)[a-zA-Z0-9 $!.]*not[a-zA-Z0-9 $!.]*verified/g;
    if ((Helper.resolveErrorMessage(error) as string).toLowerCase().match(regex)) {
      this.openModal(this.modelEvent, 'verificationOTPModal');
    } else {
      this.notificationSvc.createToastNotification('new-susbcription', Helper.resolveErrorMessage(error), CloudNotificationStyle.danger);
    }
  }



  removeReservationFromStorage() {
    localStorage.removeItem('reservedClientLicenses');
    localStorage.removeItem('reservedServerLicenses');
    localStorage.removeItem('serverOnlyLicenses');
    localStorage.removeItem('couponNo');
    localStorage.removeItem('support24x7');
    localStorage.removeItem('reservedClientPrice');
    localStorage.removeItem('client24x7Price');
    localStorage.removeItem('supportClientPrice');
    localStorage.removeItem('reservedServerPrice');
    localStorage.removeItem('serverOnlyPrice');
    localStorage.removeItem('server24x7Price');
    localStorage.removeItem('serverOnly24x7Price');
    localStorage.removeItem('supportServerPrice');
    localStorage.removeItem('supportOnlyServerPrice');
    localStorage.removeItem('totalDiscountPrice');
  }

  isAzureVendor(): boolean {
    return Helper.getVendor(this.vendor).vendorName === 'azure' ? true : false;
  }

  paidSubscriptionRegistrationSucess() {
    this.openModal(this.successfulRegistrationPaidModal,'successfulRegistrationModal');
  }

  createRedirectModelForm() {
    return this.formBuilder.group({
      deplymentModalOption: new FormControl(true)
    })
  }

  redirectToDeployEnviroment() {
    let deploymentOption = this.redirectModelForm.controls.deplymentModalOption.value;
    if (deploymentOption) {
      localStorage.setItem('deploymentRedirection', 'auto');
      localStorage.removeItem('currentTab');
      localStorage.removeItem('password');
      localStorage.removeItem('subscriptionID');
      localStorage.removeItem('manualUserCreation');
      this.router.navigate([environment.routes.deployment_automatic], {
        queryParams: { subscriptionUid: this.subscriptionUid, vendorName: this.isAzureVendor() ? 'azure' : 'aws' }
      });
    }
    else if (!deploymentOption) {
      localStorage.setItem('deploymentRedirection', 'manual');
      this.router.navigate([environment.routes.deployment_manual]);
      // this.subscriptionCreateSvc.removeLocalStorageData();
      this.router.navigate([environment.routes.deployment_manual], {
        queryParams: { subscriptionUid: this.subscriptionUid, vendorName: this.isAzureVendor() ? 'azure' : 'aws' }
      });
    }

    this.modalSvc.dismissAll(this.modelEvent);
  }

  successfulRegistrationModalNext(step: number) {
    if (step === 1)
      this.successfulRegistrationModalStepOne = false;
    else {
      this.redirectToDeployEnviroment();
    }
  }

  redirectToDashboard() {
    // this.subscriptionCreateSvc.removeLocalStorageData();
    this.router.navigate([environment.routes.subscription]);
    this.modalSvc.dismissAll(this.modelEvent);
  }

  redirectToPaidOptions() {
    // this.subscriptionCreateSvc.removeLocalStorageData();
    // this.router.navigate([environment.routes.buy_options], {
    //   queryParams: {
    //     subscriptionId: this.cloudSubscription.id
    //   }
    // });
    // this.modalSvc.dismissAll(this.modelEvent);
  }

  onPasswordShowClick(passwordField: string) {

    if ('passwordShow' === passwordField) {
      this.passwordShow = !this.passwordShow;
    } else if ('passwordConfirmShow' === passwordField) {
      this.passwordConfirmShow = !this.passwordConfirmShow;
    }
  }

  closeModal(updateEmail: boolean = false) {
    this.modalSvc.dismissAll();
  }

  redirectToPreviousPage(e: Event) {
    e.preventDefault()
    this.location.back();
  }
}
